import { createAsyncThunk } from '@reduxjs/toolkit';
import callRpc from '~/utils/call-rpc';
import { actions as notificationActions } from '@bufferapp/notifications/lib/reducer';
import type { AppDispatch, RootState } from '~/store';

export const cleanQueue = createAsyncThunk<
  boolean,
  { profileId: string },
  { state: RootState; dispatch: AppDispatch }
>(
  'generalSettings/cleanQueue',
  async ({ profileId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await callRpc('cleanQueue', {
        profileId,
      });

      if (!response.success) {
        throw new Error(response.message);
      }

      dispatch(
        notificationActions.createNotification({
          notificationType: 'success',
          message: 'Awesome! Your queue has been successfully cleaned.',
        })
      );

      return true;
    } catch (error) {
      const message = `Sorry! Something went wrong while cleaning your queue: ${error.message}. Would you be up for trying again?`;
      dispatch(
        notificationActions.createNotification({
          notificationType: 'error',
          message,
        })
      );

      return rejectWithValue(message);
    }
  }
);
